import { Grid } from '@mui/material';
import { memo } from 'react';
import { FormikErrors, FormikTouched } from 'formik';
import EnrollmentList from 'shell/components/shared/enrollment-list';
import { AccordionDrivingLicenseBookletForm } from 'shell/components/shared/sipo-person-form/new-person';

interface DrivingLicenseBookletFormProps {
  values?: AccordionDrivingLicenseBookletForm;
  errors?: FormikErrors<AccordionDrivingLicenseBookletForm>;
  touched?: FormikTouched<AccordionDrivingLicenseBookletForm>;
  onChange: (
    key: keyof AccordionDrivingLicenseBookletForm,
    value: AccordionDrivingLicenseBookletForm[keyof AccordionDrivingLicenseBookletForm]
  ) => void;
}

const DrivingLicenseBookletFormComponent = ({
  values,
  onChange,
  errors,
  touched,
}: DrivingLicenseBookletFormProps): React.ReactElement => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={4}>
        <EnrollmentList
          required
          label="Possesso autoveicoli"
          aria-label="Possesso autoveicoli"
          value={values?.motorVehicles || ''}
          onChange={(value) => {
            onChange('motorVehicles', value);
          }}
          error={touched?.motorVehicles && Boolean(errors?.motorVehicles)}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <EnrollmentList
          required
          label="Titolare patente"
          aria-label="Titolare patente"
          value={values?.drivingLicense || ''}
          onChange={(value) => {
            onChange('drivingLicense', value);
          }}
          error={touched?.drivingLicense && Boolean(errors?.drivingLicense)}
        />
      </Grid>
    </Grid>
  );
};

DrivingLicenseBookletFormComponent.displayName = 'Form Driving License BookletForm component';

const DrivingLicenseBookletForm = memo(DrivingLicenseBookletFormComponent);

export default DrivingLicenseBookletForm;
